import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useModalReducer = () => useSelector((state: ApplicationState) => state.modal);
